import React from "react";
import MainPage from "./pages/MainPage";
import "./App.css";

const App: React.FC = () => {
  return <MainPage />;
};

export default App;
